import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useApp } from "../context/AppContext";
import api from "../api";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { Avatar, AvatarFallback, AvatarImage } from "./ui/avatar";
import { Badge } from "./ui/badge";
import { SquareKanban } from "lucide-react";

export default function WorkloadCard() {
  const { t } = useApp();
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/tasks/workload").then((r) => setData(r.data)).catch(() => {}); }, []);
  if (!data) return null;
  const rows = data.rows.filter((r) => r.open || r.done_week || r.overdue);
  return (
    <Card data-testid="workload-card">
      <CardHeader>
        <CardTitle className="flex items-center justify-between gap-2">
          <span className="flex items-center gap-2"><SquareKanban className="h-4 w-4 text-emerald-500" />{t("dash.workload")}</span>
          <Link to="/tasks" className="text-xs font-normal text-primary hover:underline" data-testid="workload-open-board">{t("dash.openBoard")}</Link>
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        {rows.length === 0 && <div className="text-sm text-muted-foreground" data-testid="workload-empty">{t("common.noData")}</div>}
        {rows.map((r) => (
          <div key={r.user_id} className="flex items-center gap-3 text-sm" data-testid={`workload-row-${r.user_id}`}>
            <Avatar className="h-7 w-7"><AvatarImage src={r.picture} /><AvatarFallback className="text-[10px]">{r.name.slice(0, 2).toUpperCase()}</AvatarFallback></Avatar>
            <div className="flex-1 min-w-0">
              <div className="font-medium truncate">{r.name}</div>
              <div className="text-[10px] text-muted-foreground">{r.open} {t("dash.wlOpen")} · {r.due_week} {t("dash.wlDueWeek")}</div>
            </div>
            <div className="flex gap-1 shrink-0">
              <Badge className="bg-emerald-500/15 text-emerald-500 border-emerald-500/30 text-[10px]" title={t("dash.wlDoneWeek")} data-testid={`workload-done-${r.user_id}`}>✓ {r.done_week}</Badge>
              <Badge variant={r.overdue ? "destructive" : "secondary"} className="text-[10px]" title={t("dash.wlOverdue")} data-testid={`workload-overdue-${r.user_id}`}>! {r.overdue}</Badge>
            </div>
          </div>
        ))}
        {data.unassigned_open > 0 && <div className="text-xs text-amber-500" data-testid="workload-unassigned">{data.unassigned_open} {t("dash.wlUnassigned")}</div>}
      </CardContent>
    </Card>
  );
}
